import { Pipe, PipeTransform } from '@angular/core';
import isNull from 'lodash/isNull';

/**
 * This pipe transforms an unknown state of an 'open-ended' question
 * e.g: q: Do you know xxxx ? a: No
 */
@Pipe({
    name: 'openEndedAnswer',
    standalone: false
})
export class OpenEndedAnswerPipe implements PipeTransform {
  transform(value: string): any {
    return !isNull(value) ? (value === 'No' ? 'Not known' : value) : '-';
  }
}
